import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["yearSection"]
    static values = { selectedYear: String }

    connect() {
        if (this.selectedYearValue) {
            this.scrollToYear()
        }
    }

    selectedYearValueChanged() {
        if (this.selectedYearValue) {
            this.scrollToYear()
        }
    }

    eventYearClick(event) {
        const target = event.target
        let targetId = target.dataset.itemId
        if (!targetId) {
            targetId = target.parentNode.dataset.itemId
        }
        if (!targetId) {
            targetId = target.parentNode.parentNode.dataset.itemId
        }

        const timelineItems = document.querySelectorAll(".timeline-item")
        timelineItems.forEach(item => {
            const parent = item.parentNode
            const itemId = parent.dataset.itemId
            const childElement = item.children[0]

            if (itemId === targetId) {
                parent.removeAttribute('data-action')

                childElement.className = ''
                childElement.classList.add('custom-text', 'xl:text-[7.75rem]', 'lg:text-[5.0625rem]', 'text-[3.625rem]', 'text-gray-400')
            }
            else {
                if (!parent.dataset.action) {
                    parent.dataset.action = 'click->views--pages--main-area--home--archive--list-archives--index#eventYearClick'
                }
                childElement.className = ''
                childElement.classList.add(
                    'custom-text',
                    'text-black',
                    'xl:text-[7.75rem]',
                    'lg:text-[5.0625rem]',
                    'text-[3.625rem]',
                    'hover:underline',
                    'cursor-pointer'
                )
            }
        })

        this.selectedYearValue = targetId
        this.scrollToYear()
    }

    scrollToYear() {
        const targetYear = this.selectedYearValue
        if (!targetYear) return

        setTimeout(() => {
            const yearSection = this.yearSectionTargets.find(section =>
                section.dataset.year === targetYear
            )

            if (yearSection) {
                yearSection.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                })

            }
        }, 100)
    }
}
